module.exports = __webpack_public_path__ + "img/baojia.4055ad06.svg";